// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var className = "text-lg md:text-base";

exports.className = className;
/* No side effect */
